import React, { useState, useEffect } from "react";
import Empsidebar from "../components/Empsidebar";
import Empheader from "../components/Empheader";
import Uppercase from "../../admin/components/Uppercase";
import { FcViewDetails } from "react-icons/fc";
import { FcMoneyTransfer } from "react-icons/fc";
import "./Empsearchclient.css";
import axios from "axios";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";


const Empsearchclient = () => {
  const [openSidebarToggle, setOpenSidebarToggle] = useState(false);
  const openSidebar = () => {
    setOpenSidebarToggle(!openSidebarToggle);
  };

  const navigate = useNavigate();
  const token = Cookies.get("token");
  const [empmail,setEmpmail] = useState("");

  useEffect(() => {

if (!token) {
    navigate("/login");
  } else {
    const decoded = jwtDecode(token);
    setEmpmail(decoded.email);

    if (decoded.role !== "employee") {
      navigate("/login");
    }
  }
  fetchUsername();
  },[token,navigate])

  const [username,setUsername] = useState("");

  const fetchUsername = async () => {
    try {
      const response = await axios.get("https://api.litaxfilers.com/employeeclientusername", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data.success) {
        setUsername(response.data.result[0].userName);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const [toggle, setToggle] = useState(1);

  function updateToggle(id) {
    setToggle(id);
  }

  const [searchClient, SetsearchClient] = useState("");
  const [clientEmail, setClientEmail] = useState("");
  const [clientDetails, setclientDetails] = useState([]);
  const [referrals, setReferrals] = useState([]);
  const fetchDetails = async () => {
    try {
      const response = await axios.post(
        "https://api.litaxfilers.com/get/empclientdetails",
        { searchClient, username }
      );
      if (response.data.success) {
        setclientDetails(response.data.result);
        setClientEmail(response.data.result[0].email);
      } else {
        setclientDetails([]);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const fetchReferrals = async () => {
    try {
      const response = await axios.post(
        "https://api.litaxfilers.com/empfetchReferrals",
        {
          username: clientEmail,
        }
      );
      if (response.data.success) {
        setReferrals(response.data.referrals);
      } else {
        console.error("Error fetching referrals:", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching referrals:", error);
    }
  };

  useEffect(() => {
    if (clientEmail) fetchReferrals();
  }, [clientEmail]);

  const handleEditPassword = async () => {
    try {
      const response = await axios.put("https://api.litaxfilers.com/editemppwd", {
        clientEmail,
      });
      if (response.data.success) {
        toast.success("Password changed successfully to 123456");
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div>
      <Uppercase />
      <div className="invoice-grid-container">
        <Empheader openSidebar={openSidebar} />
        <Empsidebar
          openSidebarToggle={openSidebarToggle}
          openSidebar={openSidebar}
        />
        <main className="main-container mt-2">
          <div className="container">
            <h4 className="mt-2">Search Client</h4>
            <hr />
            <div className="d-flex justify-content-center gap-3">
              <div className="col-lg-4">
                <input
                  className="form-control"
                  type="text"
                  placeholder="Search Client"
                  onChange={(e) => SetsearchClient(e.target.value)}
                />
              </div>
              <button
                type="button "
                className="btn btn-primary"
                onClick={fetchDetails}
              >
                Search
              </button>
            </div>
            <hr />
            <div className="row">
              <div className="col-lg-3">
                <ul className="list-unstyled d-flex flex-column gap-2 border rounded p-3 product_links justify-content-center justify-content-lg-start">
                  <li
                    className={`col-12 border rounded text-center py-2 fw-bold  ${
                      toggle === 1 ? "productactive" : ""
                    }`}
                    onClick={() => updateToggle(1)}
                  >
                    Client Details <FcViewDetails />
                  </li>
                  <li
                    className={`col-12 border rounded text-center py-2 fw-bold ${
                      toggle === 2 ? "productactive" : ""
                    }`}
                    onClick={() => updateToggle(2)}
                  >
                    Referral Bonus <FcMoneyTransfer />
                  </li>
                </ul>
              </div>
              <div className="col-lg-8">
                <div
                  className={
                    toggle === 1 ? "product_showcontent" : "product_content"
                  }
                >
                  {clientDetails.length > 0 ? (
                    clientDetails.map((client) => (
                      <div>
                        <div>
                          <label htmlFor="name">Name:</label>
                          <div className="col-lg-6">
                            <input
                              type="text"
                              className="form-control"
                              value={client.client_name}
                            />
                          </div>
                        </div>
                        <div className="mt-2">
                          <label htmlFor="email">Email:</label>
                          <div className="col-lg-6">
                            <input
                              type="text"
                              className="form-control"
                              value={client.email}
                            />
                          </div>
                        </div>
                        <div className="mt-2">
                          <label htmlFor="contact">Contact No:</label>
                          <div className="col-lg-6">
                            <input
                              type="text"
                              className="form-control"
                              value={client.contact}
                            />
                          </div>
                        </div>
                        <div className="mt-2">
                          <button
                            className="btn btn-sm btn-primary"
                            onClick={handleEditPassword}
                          >
                            Change Password to 123456
                          </button>
                        </div>
                      </div>
                    ))
                  ) : (
                    <p>No records found</p>
                  )}
                </div>

                <div
                  className={
                    toggle === 2 ? "product_showcontent" : "product_content"
                  }
                >
                  <div className="table-responsive">
                    <table className="table table-bordered table-hovered">
                      <thead className="table-primary">
                        <tr>
                          <td>S.No</td>
                          <td>Referral Name</td>
                          <td>Referral Email</td>
                          <td>Referral Phone</td>
                          <td>Date And Time</td>
                        </tr>
                      </thead>
                      <tbody>
                        {referrals.map((each, index) => (
                          <tr key={each.id}>
                            <td>{index + 1}</td>
                            <td>{each.name}</td>
                            <td>{each.email}</td>
                            <td>{each.phone}</td>
                            <td>{each.dateandtime}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default Empsearchclient;
